import componentFn from '../../styles/objects/component'

export default ({
    colors,
    spacings,
    images,
    fontFamilies,
    fontWeights,
    fontSizes,
    textTransforms
  }) => {
    const component = componentFn({
      colors,
      spacings,
      images,
      fontFamilies,
      fontWeights,
      fontSizes,
      textTransforms
    })
const styles = {
    divAlignPhoneNum: {
        verticalAlign: 'middle!important',
        paddingTop: '49px!important'
     },
    checkmark:{
        display:'inline-block',
        width: '10px',
        height:'22px',
        msTransform: 'rotate(45deg)', /* IE 9 */
        webkitTransform: 'rotate(45deg)', /* Chrome, Safari, Opera */
        transform: 'rotate(45deg)',
        position: 'absolute',
        marginLeft: '-23px'
    },
    
    checkmarkStem: {
        position: 'absolute',
        width:'3px',
        height:'11px',//'9px',
        backgroundColor:'#fff',
        left:'11px',
        top:'5px',
    },
    checkmarkKick: {
        position: 'absolute',
        width:'3px',
        height:'3px',
        backgroundColor:'#fff',
        // left:'8px',
        // top:'12px'
        top: '13px',
        left: '8px'
    },
    checkmarkCircle:{
        position: 'absolute',
        width:'22px',
        height:'22px',
        backgroundColor: 'green',
        borderRadius:'11px',
        left:'0',
        top:'0'
    },
    otpWidth:{
        width:'32rem!important'
    },    
    fullFieldWidth: {
        width:'100%!important'
    },
    grayed: {
        padding: "1rem 1rem 2rem 1rem",
        borderRadius: "6px",
        backgroundColor: "#eee"
    },
    grayedText: {
        backgroundColor: "#eee !important"
    },
    componentTitle: {
        display: "block",
        marginBottom: "1rem",
        color: "#201849"
    }
    // gap :
    // {
    //     display:"none"
    // },
    // ibantextfont :
    // {
    //     fontSize: "0.875rem"   
    // }
}
return { ...component, ...styles }
}




// WEBPACK FOOTER //
// ./components/textbox/styles.js